// extracted by mini-css-extract-plugin
module.exports = {"widgetPanel":"WidgetPanel_widgetPanel__2OqbI","panel":"WidgetPanel_panel__1lPnX","openBtn":"WidgetPanel_openBtn__3Im6Y"};